import { render } from "./CustomTextArea.vue?vue&type=template&id=66f6d5aa&scoped=true"
import script from "./CustomTextArea.vue?vue&type=script&lang=js"
export * from "./CustomTextArea.vue?vue&type=script&lang=js"

import "./CustomTextArea.vue?vue&type=style&index=0&id=66f6d5aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f6d5aa"]])

export default __exports__